import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// third-party modules
import { TranslateModule } from '@ngx-translate/core';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { NgxsModule } from '@ngxs/store';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

// bayclubs modules
import { DropDownModule } from '@bayclubs/drop-down';
import { BcRecurringModule } from '@bayclubs/recurring';

// application modules
import { SharedModule } from '@shared/shared.module';

// store
import { CourtEventDetailsState } from './+store/court-event-details.state';

// containers
import { CourtClassItemDetailsComponent } from '../court-event-details/containers/court-class-item-details/court-class-item-details.component';
import { CourtBlockedSlotItemDetailsComponent } from './containers/court-blocked-slot-item-details/court-blocked-slot-item-details.component';
import { CourtBookingItemDetailsComponent } from './containers/court-booking-item-details/court-booking-item-details.component';

// components
import { SpinnerModule } from '@bayclubs/spinner';
import { BayclubsUiCoreModule } from '@bayclubs/ui-core';
import { CourtBookingPlayersComponent } from '../court-event-details/components/court-booking-players/court-booking-players.component';
import { CourtEventNotesDetailsComponent } from './components/court-event-notes-details/court-event-notes-details.component';
import { CourtEventTimelineComponent } from './components/court-event-timeline/court-event-timeline.component';

@NgModule({
    declarations: [
        CourtBlockedSlotItemDetailsComponent,
        CourtBookingItemDetailsComponent,
        CourtClassItemDetailsComponent,
        CourtEventTimelineComponent,
        CourtBookingPlayersComponent,
        CourtEventNotesDetailsComponent
    ],
    imports: [
        CommonModule,
        NgxsModule.forFeature([CourtEventDetailsState]),
        NgxsFormPluginModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule.forChild(),
        TooltipModule.forRoot(),
        DropDownModule,
        BcRecurringModule,
        SharedModule,
        SpinnerModule,
        BayclubsUiCoreModule
    ],
    exports: [CourtBlockedSlotItemDetailsComponent, CourtClassItemDetailsComponent, CourtBookingItemDetailsComponent]
})
export class CourtEventDetailsModule { }
